import React, { useState, createContext, useRef } from "react";
import PropTypes from "prop-types";

import { radiusToZoom } from "../helpers/helpers";

export const StoreLocatorContext = createContext();

export const StoreLocatorProvider = props => {
	const [view, setView] = useState("map");
	const [radius, setRadius] = useState("5");
	const [service, setService] = useState("");
	const [location, setLocation] = useState("");
	const [map, setMap] = useState(null);
	const [searchValue, setSearchValue] = useState("");
	const [locationSearchVal, setLocationSearchVal] = useState("");
	const [initStoreLocator, setInitStoreLocator] = useState(false);
	const [details, setDetails] = useState({});
	const [errorText, setErrorText] = useState("");
	const [type, setType] = useState("");
	const [presetFilter, setPresetFilter] = useState("");
	const [previousView, setPreviousView] = useState("");
	const [zoomOverride, setZoomOverride] = useState("");
	const [consentComplete, setConsentComplete] = useState(false);
	const [filterHeadingText, setFilterHeadingText] = useState("all locations near you");
	const viewRef = useRef(view);
	const previousViewRef = useRef(previousView);
	const exitStoreLoc = useRef(false);
	const [paramsRecord, setParamsRecord] = useState({});
	const [resultsReturning, setResultsReturning] = useState(false);
	const [servicesLoading, setServicesLoading] = useState(false);
	const [consentStarted, setConsentStarted] = useState(false);
	const [currentFilter, setCurrentFilter] = useState({});
	const [loading, setLoading] = useState(false);
	const [townsLoading, setTownsLoading] = useState(false);
	const [fixedHeading, setFixedHeading] = useState(false);
	const [towns, setTowns] = useState([]);

	const [services, setServicesData] = useState([]);
	const [errorLinkText, setErrorLinkText] = useState("");

	const minZoom = 3.5;
	const maxZoom = 3;
	const [zoomLevel, setZoomLevel] = useState(13);

	// Ireland boundaries - not letting user outside of Ireland
	const irelandBounds = {
		latLngBounds: {
			north: 59.126396,
			south: 51.393172,
			west: -11.1578,
			east: -5.068126
		},
		strictBounds: false
	};

	const defaultLatLng = {
		lat: 53.34933275,
		lng: -6.26065885
	};

	const [center, setCenter] = useState(defaultLatLng);
	const [sharedPosition, setSharedPosition] = useState(defaultLatLng);

	// if filter is preset when arriving on app
	const setFilterPreset = preset => {
		setType(preset.replace(/-/g, " "));

		// used by analytics
		setPresetFilter(preset.replace(/-/g, " "));
	};

	const handleZoomLevel = level => {
		setZoomLevel(level);
	};

	const resetType = () => {
		setType("");
		setCurrentFilter({});
		setFilterHeadingText("all locations near you");
	};

	const handleSetPreviousView = view => {
		setPreviousView(view);
		previousViewRef.current = view;
		setParamsRecord({ view: "details" });
	};

	const setExitApp = exit => {
		exitStoreLoc.current = exit;
	};

	const setUpdatedView = updatedView => {
		setView(updatedView);
		viewRef.current = updatedView;
		if (updatedView === "list") {
			// if using the list view then the radius should be set to 5
			setRadius("5");
			setZoomOverride(radiusToZoom(5));
			handleZoomLevel(radiusToZoom(5));
		}
	};

	return (
		<StoreLocatorContext.Provider
			value={{
				view,
				setUpdatedView,
				zoomLevel,
				handleZoomLevel,
				minZoom,
				maxZoom,
				radius,
				setRadius,
				details,
				setDetails,
				service,
				setService,
				initStoreLocator,
				setInitStoreLocator,
				searchValue,
				setSearchValue,
				map,
				setMap,
				center,
				setCenter,
				errorText,
				setErrorText,
				irelandBounds,
				type,
				setType,
				setFilterPreset,
				filterHeadingText,
				setFilterHeadingText,
				previousView,
				setPreviousView,
				zoomOverride,
				setZoomOverride,
				viewRef,
				previousViewRef,
				handleSetPreviousView,
				consentComplete,
				setConsentComplete,
				defaultLatLng,
				presetFilter,
				setPresetFilter,
				paramsRecord,
				setParamsRecord,
				resultsReturning,
				setResultsReturning,
				services,
				setServicesData,
				servicesLoading,
				setServicesLoading,
				sharedPosition,
				setSharedPosition,
				consentStarted,
				setConsentStarted,
				resetType,
				errorLinkText,
				setErrorLinkText,
				currentFilter,
				setCurrentFilter,
				locationSearchVal,
				setLocationSearchVal,
				location,
				setLocation,
				loading,
				setLoading,
				towns,
				setTowns,
				townsLoading,
				setTownsLoading,
				fixedHeading,
				setFixedHeading,
				exitStoreLoc,
				setExitApp
			}}
		>
			{props.children}
		</StoreLocatorContext.Provider>
	);
};

StoreLocatorProvider.propTypes = {
	children: PropTypes.object
};
